import React from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import Lightbox from "lightbox-react";
import "lightbox-react/style.css";
import MetaTags from "react-meta-tags";

import HomeStyles from "./Home.css";
import HowDoesItWork from "./components/HowDoesItWork";

/* eslint-disable import/no-webpack-loader-syntax */

import HeaderImage from "./images/header.jpg";
import HeaderImageStripeLeft from "./images/header-stripe-left.png";
import HeaderImageStripeRight from "./images/header-stripe-right.png";
import YouTubeVideoThumbnail from "./images/youtube-video-thumbnail.png";
import VideoPlayButtonIcon from "-!svg-react-loader!./icons/youtube-play.svg";

import utilities from "./components/Utilities";
let Utilities = new utilities();

export default class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      definitons: {},
      latestWork: [],
      isOpen: false,
      photoIndex: 0
    };
  }

  componentDidMount() {
    document.title =
      "FrameIT " + window.countryName + " | Online Custom Picture Frame Maker";
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    let defintions = window.globalVars.definitons;
    let defintionsAssociative = {};

    if (!Utilities.isENU(defintions)) {
      for (var i = 0; i < defintions.length; i++) {
        let type = defintions[i].type;
        if (
          [
            "hero-title",
            "frames-crafted",
            "hero-subhead",
            "hero-button",
            "hdiw-title",
            "hdiw-subhead",
            "hdiw-feature-1-title",
            "hdiw-feature-1-description",
            "hdiw-feature-2-title",
            "hdiw-feature-2-description",
            "hdiw-feature-3-title",
            "hdiw-feature-3-description",
            "hdiw-feature-4-title",
            "hdiw-feature-4-description",
            "latest-work-title"
          ].indexOf(type) !== -1
        ) {
          defintionsAssociative[type] = defintions[i].valueStr;
        }
      }
    }

    this.setState({
      definitons: defintionsAssociative
    });

    this.getLatestWork();
  }

  getLatestWork = () => {
    window.globalVars.server.api({
      method: "get",
      url: "/api/media/latest-work/6",
      data: {},
      then: function(res) {
        if (Utilities.isENU(res.data.data)) {
          // ToastStore.error("Coudln't get meida");
        } else {
          this.setState({
            latestWork: res.data.data
          });
        }
      }.bind(this),
      catch: function(e) {}.bind(this)
    });
  };

  createCartItem = () => {
    window.location.href = "/build/size/" + Utilities.createCartItem();
  };

  render() {
    return (
      <div className='home'>
        <MetaTags>
          <meta
            id='meta-description'
            name='description'
            content={
              "Design and build your custom picture frame online with FrameIT " +
              window.countryName +
              ". Input your dimensions, choose your frame, mat border and ship to your door."
            }
          />
          <meta name='robots' content='index' />
          <meta name='googlebot' content='index' />
        </MetaTags>

        <div className='hero-wrapper'>
          <div
            className='pattern-left'
            style={{
              backgroundImage: `url('${HeaderImageStripeLeft}')`
            }}
          />

          <div
            className='pattern-right'
            style={{
              backgroundImage: `url('${HeaderImageStripeRight}')`
            }}
          />

          <div className='main-container hero'>
            <div className='side'>
              <h1>
                {this.state.definitons["hero-title"] ||
                  "Custom framing made simples"}
              </h1>

              <h2>
                {this.state.definitons["hero-subhead"] ||
                  "High quality, hand crafted custom frames, built online and delivered to your door."}
              </h2>

              <div>
                <a
                  onClick={() => {
                    this.createCartItem();
                  }}
                  href='#'
                  className='cta'
                >
                  {this.state.definitons["hero-button"] || "Start Framing"}
                </a>
                <div className='crafted'>
                  <div>
                    <label>Frames Crafted</label>
                    <p>{this.state.definitons["frames-crafted"] || "100+"}</p>
                  </div>
                </div>
              </div>
            </div>

            <div
              className='hero-img'
              style={{
                backgroundImage: `url('${HeaderImage}')`
              }}
            />

            <div className='hero-img-mobile'>
              <img src={HeaderImage} />
            </div>
          </div>
        </div>

        <HowDoesItWork definitons={this.state.definitons} />

        <div className='main-container'>
          <div className='video-intro'>
            <div className='video-wrapper'>
              <div className='video'>
                {!this.state.videoStarted && (
                  <div
                    className='video-preview'
                    onClick={e => {
                      e.preventDefault();
                      let el = document.getElementById("player");
                      el.src += "?autoplay=1";
                      this.setState({ videoStarted: true });
                    }}
                  >
                    <img
                      style={{ width: "100%" }}
                      src={YouTubeVideoThumbnail}
                    />
                    {/*<VideoPlayButtonIcon />*/}
                  </div>
                )}
                <iframe
                  allowfullscreen='allowfullscreen'
                  mozallowfullscreen='mozallowfullscreen'
                  msallowfullscreen='msallowfullscreen'
                  oallowfullscreen='oallowfullscreen'
                  webkitallowfullscreen='webkitallowfullscreen'
                  id='player'
                  style={{
                    display: this.state.videoStarted ? "block" : "none"
                  }}
                  ref={this.youtube}
                  src='https://www.youtube.com/embed/Td2ryGbeYNA'
                  frameborder='0'
                  allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture allowfullscreen'
                ></iframe>
              </div>
              <div className='dummy' />
            </div>
            <div className='info'>
              <h2>Meet a happy FrameIT customer</h2>
              <p>
                Full-time artist Khalsom gave us a peek inside her studio and
                explained why she enjoys leveraging FrameIT to custom frame her
                finished artworks.
              </p>
              <p>
                Skip the trip to the framing shop, design your perfect custom
                frame online, and receive directly to your door.
              </p>
            </div>
          </div>
        </div>

        <div className='latest-work'>
          <div className='main-container'>
            <h2>
              {this.state.definitons["latest-work-title"] ||
                "See some of our latest frames"}
            </h2>

            <div className='frames clearfix'>
              {this.state.latestWork.map((item, i) => {
                return (
                  <div className='image'>
                    <img
                      onClick={() => {
                        this.setState({
                          isOpen: true,
                          photoIndex: i
                        });
                      }}
                      src={
                        "https://s3-ap-southeast-1.amazonaws.com/frameitsg/latest-work/" +
                        item.name
                      }
                    />
                  </div>
                );
              })}
            </div>

            {this.state.isOpen && (
              <Lightbox
                mainSrc={
                  "https://s3-ap-southeast-1.amazonaws.com/frameitsg/latest-work/" +
                  this.state.latestWork[this.state.photoIndex].name
                }
                nextSrc={
                  "https://s3-ap-southeast-1.amazonaws.com/frameitsg/latest-work/" +
                  this.state.latestWork[
                    (this.state.photoIndex + 1) % this.state.latestWork.length
                  ].name
                }
                prevSrc={
                  "https://s3-ap-southeast-1.amazonaws.com/frameitsg/latest-work/" +
                  this.state.latestWork[
                    (this.state.photoIndex + this.state.latestWork.length - 1) %
                      this.state.latestWork.length
                  ].name
                }
                onCloseRequest={() => this.setState({ isOpen: false })}
                onMovePrevRequest={() =>
                  this.setState({
                    photoIndex:
                      (this.state.photoIndex +
                        this.state.latestWork.length -
                        1) %
                      this.state.latestWork.length
                  })
                }
                onMoveNextRequest={() =>
                  this.setState({
                    photoIndex:
                      (this.state.photoIndex + 1) % this.state.latestWork.length
                  })
                }
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Home.js